import React from 'react'
import ReactDOM from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import App from './App'
import ExamPage from './pages/ExamPage'
import SummaryPage from './pages/SummaryPage'
import AdminPage from './pages/AdminPage'
import LivePage from './pages/LivePage'
import ReplayPage from './pages/ReplayPage'

const router = createBrowserRouter([
  { path: '/', element: <App /> },
  { path: '/admin', element: <AdminPage /> },
  { path: '/podsumowanie/:sessionId', element: <SummaryPage /> },
  { path: '/:exam/egzamin', element: <ExamPage /> },
  { path: '/:exam/egzamin/:token', element: <ExamPage /> },
  { path: '/live/:sessionId', element: <LivePage /> },
  { path: '/replay/:sessionId', element: <ReplayPage /> }
])

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
)
